<gol-environment-banner></gol-environment-banner>
<gol-header-component></gol-header-component>
<gol-message-center></gol-message-center>
<router-outlet></router-outlet>
<gol-footer-component></gol-footer-component>
<gol-idle-component></gol-idle-component>

